export default __webpack_public_path__ + "static/media/IBimageVarusValgus.aca7a004.png";